<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->

    <BreadCrumb :data="breadcrumb" :title="'词条详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 学者详情页基本信息 -->
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <img
            v-if="entryDetail.image"
            :src="entryDetail.image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>作者中文名</h4>
            <span>{{ entryDetail.author_chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>作者英文名</h4>
            <span>{{ entryDetail.author_english_name }}</span>
          </li>
          <li class="exclusive">
            <h4>中文名</h4>
            <span>{{ entryDetail.chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <span>{{ entryDetail.english_name }}</span>
          </li>
          <li class="one-third">
            <h4>词条分类</h4>
            <span>{{
              entryDetail.classification &&
              entryDetail.classification.chinese_name
                ? entryDetail.classification.chinese_name
                : "暂无"
            }}</span>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="entryDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <!-- <li class="exclusive">
            <h4>简介</h4>
            <span
              v-if="entryDetail.chinese_detail != null"
              v-html="entryDetail.chinese_detail"
            ></span>
            <span v-if="entryDetail.chinese_detail == null">暂无</span>
          </li> -->
        </ul>
      </div>
    </div>
    <!-- 修改学者详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="entryDetail.image"
            :width="220"
            :height="180"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>作者中文名</h4>
            <keywordsinput
              :maxLen="18"
              :_key="1"
              v-model="entryDetail.author_chinese_name_list"
            ></keywordsinput>
          </li>
          <li class="exclusive">
            <h4>作者英文名</h4>
            <keywordsinput
              :maxLen="18"
              :_key="2"
              v-model="entryDetail.author_english_name_list"
            ></keywordsinput>
          </li>
          <li class="exclusive">
            <h4>中文名</h4>
            <el-input
              v-model="entryDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <el-input
              v-model="entryDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li class="one-third">
            <h4>词条分类</h4>
            <el-select
              v-model="entryDetail.classification.id"
              clearable
              placeholder="词条分类"
              class="tag"
            >
              <el-option
                v-for="(item, index) in classificationList"
                :key="index"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="entryDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="pc-dataDetail-intro">
      <h2>词条介绍</h2>
      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="15"
          placeholder="请输入内容"
          v-model="entryDetail.chinese_detail"
        >
        </el-input>
        <p v-else>
          {{ entryDetail.chinese_detail }}
        </p>
      </div>
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          v-if="isEditting"
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="entryDetail.english_detail"
        >
        </el-input>
        <p v-else>
          {{ entryDetail.english_detail }}
        </p>
      </div>
    </div>
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import {
  entryDetail_Api,
  entryClassificationSearch_Api,
  createEntryDetail_Api,
  updateEntryDetail_Api,
} from "@/apis/entry.api";
import TagDetail from "@/components/template/TagDetail";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    TagDetail,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "词条列表", link: "/admin/entryList" },
        {
          name: `${
            (
              this.entryDetail.chinese_name
                ? this.entryDetail.chinese_name
                : this.entryDetail.english_name
            )
              ? this.entryDetail.chinese_name
                ? this.entryDetail.chinese_name
                : this.entryDetail.english_name
              : ""
          }`,
          link: "/admin/entrydetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      entryDetail: {
        id: null,
        classification: { chinese_name: "" },
        author_chinese_name_list: [],
        author_english_name_list: [],
      },
      classification: {},
      classificationList: [],
      chinese_detail: "",
      english_detail: "",
    };
  },
  filters: {
    authorName: function (val) {
      val.forEach((element) => {
        console.log(element);
      });
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.method == "update") {
      this.entryDetail.id = this.$route.query.id;
      this.getEntryDetail();
    }
    entryClassificationSearch_Api().then((res) => {
      this.classificationList = res.data;
      console.log(this.classificationList);
    });
  },

  methods: {
    returnTranslate(data, flag) {
      flag == 1
        ? (this.entryDetail.english_detail = data)
        : (this.entryDetail.chinese_detail = data);
      console.log(data);
      console.log(flag);
    },
    handleSelect(item) {
      this.entryDetail.classification = item;
    },

    searchUniversity(queryString, callback) {},
    getUploadImage(img_url) {
      this.entryDetail.image = img_url;
    },
    getEntryDetail(hint) {
      entryDetail_Api(this.entryDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.entryDetail = res.data;
        this.entryDetail.author_chinese_name_list = this.entryDetail.author_chinese_name;
        this.entryDetail.author_english_name_list = this.entryDetail.author_english_name;
        console.log(this.entryDetail.author_chinese_name);
        this.entryDetail.classification == null
          ? (this.entryDetail.classification = { english_name: "" })
          : "";
        if (this.entryDetail.classification) {
          this.entryDetail.classification == null
            ? this.entryDetail.classification
            : "";
        }
        if (!this.entryDetail.update_time) {
          this.entryDetail.update_time = this.$dtime(new Date()).format(
            "YYYY-MM-DD"
          );
        }
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getEntryDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getEntryDetail("恢复成功");
    },
    view() {
      window.open("http://wupen.org/entry/" + this.$route.query.id, "_blank");
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.entryDetail);
      if (!formattedData) {
        return;
      } else {
        createEntryDetail_Api(formattedData)
          .then((res) => {
            this.entryDetail.id = res.data.id;
            this.isEditting = false;
            this.getEntryDetail();
            this.$router.push({
              path: "/admin/entrydetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.entryDetail);
      if (!formattedData) {
        return;
      } else {
        updateEntryDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getEntryDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      if (!formData.author_chinese_name || !formData.author_english_name) {
        this.$global.error(this, "请输入作者中英文标题");
        return false;
      }
      formData.entry_id = formData.id;
      formData.classification_id = formData.classification.id;

      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .keywordsTag {
  width: 100%;
}
.imgBox {
  width: 200px;
  height: 200px;
}

/deep/ .el-select {
  width: 100%;
}
.imgBox .form-content-img {
  width: 100%;
  height: 100%;
}
.no-img {
  width: 200px !important;
  height: 150px !important;
}
/deep/ .keywordsTag {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/entry/EntryDetail.vue